// This code has been changed to call as common.
// Changed from staff styling.
function adjustMargins(device) {
    var blockWidth = $(`.block-pagination`).outerWidth(true);
    var buttonPaging = $(`.block-pagination ${device} .btnCalc`);
    var buttonCount = buttonPaging.length;
    var calcMarginBtn = 0;

    var totalWidthBtn = 0;
    $(buttonPaging).each(function() {
        totalWidthBtn += $(this).outerWidth(true);
    });

    if (totalWidthBtn > blockWidth) {
        calcMarginBtn = ((totalWidthBtn - blockWidth) / buttonCount) + 1.5;
    }

    var wDevice = $(window).width();
    var tmpMg = 49;
    if (wDevice <= 480) {
        tmpMg = 25;
    }

    $(buttonPaging).each(function() {
        var marginLeft = parseFloat($(this).css('margin-left'));
        var marginRight = parseFloat($(this).css('margin-right'));
        var finalMgr = buttonCount <= 5 ? tmpMg : marginRight - calcMarginBtn;
        var finalMgl = buttonCount <= 5 ? tmpMg : marginLeft - calcMarginBtn;

        if ($(this).hasClass('paginate_next') || $(this).hasClass('paginate_previous')) {
            finalMgl = 8;
            finalMgr = 8;
        }

        if(marginRight != 0) {
            $(this).css('margin-right', finalMgr + 'px');
        }

        if(marginLeft != 0) {
            $(this).css('margin-left', finalMgl + 'px');
        }
    });
}

module.exports.adjustMargins = adjustMargins;